/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useSessionErrorHandler } from '@/data/Content/SessionErrorDialog';
import { FC } from 'react';

export const SessionErrorDialog: FC = () => {
	useSessionErrorHandler();
	return null;
};
